"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
const react_1 = __importStar(require("react"));
const PageContexts_1 = require("../Contexts/PageContexts");
const defaultValidationState = { errors: [], warnings: [], displayOptions: {} };
/**
 *  This component is used to wrap the given control in the final form Field component
 * @param controlPath The defined path of this control, as determined by final-form
 * @param controlDefinition The definition of this control. This is primarily used to determing whether the field should be read only
 * @param validationFn The validation function used to validate the warnings and errors of this control
 * @param render The render prop which is used to render the control. This is passed a set of props used to render the form control passed by the consuming application
 */
const FieldRender = props => {
    const { controlPath, validationFn, render, controlDefinition, value, values, defaultDateTimeFormat } = props;
    const { updateControlPathLocalFieldWarning, fieldValidationWarnings } = (0, PageContexts_1.useFieldValidation)();
    const { controlMap } = (0, PageContexts_1.useControlProvider)();
    const { updateVisibility } = (0, PageContexts_1.useFieldVisibility)();
    const [validationState, setValidationState] = (0, react_1.useState)(defaultValidationState);
    (0, react_1.useEffect)(() => {
        updateVisibility(validationState.displayOptions.isVisible !== false);
    }, [validationState.displayOptions.isVisible, updateVisibility]);
    (0, react_1.useEffect)(() => {
        const val = async () => {
            if (validationFn) {
                const { errors, warnings, displayOptions } = await validationFn(value, values, undefined, controlPath);
                if (!(0, lodash_isequal_1.default)(errors, validationState.errors) ||
                    !(0, lodash_isequal_1.default)(warnings, validationState.warnings) ||
                    !(0, lodash_isequal_1.default)(displayOptions || {}, validationState.displayOptions)) {
                    setValidationState({ errors, warnings, displayOptions });
                }
            }
        };
        val();
    }, [validationFn, validationState, controlPath, value, values]);
    const localRender = (0, react_1.useCallback)(({ input }) => {
        // we may want to add the entire meta to fields
        // the touch becomes true when the user click submit.
        // const touched = meta.touched || meta.modified || meta.visited;
        var _a;
        if (((_a = validationState.warnings) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            updateControlPathLocalFieldWarning(controlPath, validationState.warnings);
        }
        else {
            if (fieldValidationWarnings) {
                delete fieldValidationWarnings[controlPath];
            }
        }
        return validationState.displayOptions.isVisible === false ? (react_1.default.createElement(react_1.default.Fragment, null)) : (react_1.default.createElement(controlMap.StyleWrapper, { textColor: validationState.displayOptions.textColor || undefined, backgroundColor: validationState.displayOptions.backgroundColor || undefined }, render(Object.assign(Object.assign(Object.assign(Object.assign({}, validationState), { validationFn }), input), { label: validationState.displayOptions.title || controlDefinition.label, textColor: validationState.displayOptions.textColor, defaultDateTimeFormat: defaultDateTimeFormat }))));
        //return <Component {...props} {...validationProps} {...input} touched={meta.touched} />;
    }, [
        controlDefinition,
        render,
        validationState,
        validationFn,
        controlPath,
        fieldValidationWarnings,
        updateControlPathLocalFieldWarning,
        controlMap,
        defaultDateTimeFormat,
    ]);
    /*
      This is how final form assumes this will be done, which requires slightly different implementation on the frontend
      const type =
      controlDefinition.type === 'group' || controlDefinition.type === 'radio' ? controlDefinition.type : undefined;*/
    return localRender({
        input: {
            value: value,
            values: values,
        },
    });
};
exports.default = FieldRender;
